export default __webpack_public_path__ + "static/media/rmvideo-before.6260551c.png";